import * as Yup from 'yup';

export const useSocialNetwork = (company) => {
  const SOCIAL_NETWORKS = {
    linkedinUrl: {
      placeholder: 'https://www.linkedin.com/...',
      title: 'LinkedIn URL',
      schema: Yup.string().label('LinkedIn URL').url(),
      key: 'linkedin',
      disabled: true,
    },
    angellistUrl: {
      placeholder: 'https://www.angel.co/...',
      title: 'AngelList',
      schema: Yup.string().label('AngelList URL').url(),
      key: 'angellist',
      disabled: false,
    },
    crunchbaseUrl: {
      placeholder: 'https://www.crunchbase.com/...',
      title: 'Crunchbase',
      schema: Yup.string().label('Crunchbase URL').url(),
      key: 'crunchbase',
      disabled: false,
    },
    twitterUrl: {
      placeholder: 'https://www.twitter.co/...',
      title: 'Twitter',
      schema: Yup.string().label('Twitter URL').url(),
      key: 'twitter',
      disabled: false,
    },
    instagramUrl: {
      placeholder: 'https://www.instagram.com/...',
      title: 'Instagram',
      schema: Yup.string().label('Instagram URL').url(),
      key: 'instagram',
      disabled: false,
    },
    facebookUrl: {
      placeholder: 'https://www.facebook.com/...',
      title: 'Facebook',
      schema: Yup.string().label('Facebook URL').url(),
      key: 'facebook',
      disabled: false,
    },
  };

  const SOCIAL_NETWORKS_KEYS = Object.keys(SOCIAL_NETWORKS);

  const socials = SOCIAL_NETWORKS_KEYS.filter((key) => company[key]).reduce((acc, key) => {
    acc[SOCIAL_NETWORKS[key].key] = company[key];
    return acc;
  }, {});

  return {
    SOCIAL_NETWORKS,
    SOCIAL_NETWORKS_KEYS,
    socials,
  };
};
